import { MainFooter } from "@src/component/home/renewal/main/pc/MainFooter";
import { MainGnb } from "@src/component/home/renewal/main/pc/MainGnb";
import { MainLayout } from "@src/component/home/renewal/main/pc/MainLayout";
import { ExpertContents } from "./ExpertContents";

const ExpertPage = () => (
	<MainLayout>
		<MainGnb type="expert" />
		<ExpertContents />
		<MainFooter />
	</MainLayout>
);

export default ExpertPage;
